import { Fragment } from 'react';
import crest from '../../images/crest.svg' with { type: 'url' };
import facebook from '../../images/facebook.svg' with { type: 'url' };
import linkedIn from '../../images/linkedIn.svg' with { type: 'url' };
import type { FooterResponse } from '../../pages/api/types';
import Icon from '../generic/Icon';
import { trackFooterLinkClick } from '../utils/trackLinkClick';
import * as style from './FooterContact.module.css';

export default function FooterContact(data: Omit<FooterResponse, 'footerLinks'>) {
    return (
        <div className={style.sectionFooterContact} onClick={trackFooterLinkClick}>
            <div className="section__inner-container">
                <div className={style.footerContact}>
                    <h2>{data.title}</h2>
                    <div className={style.footerItems}>
                        <div className={style.footerOpeningHours}>
                            <h3>{data.openingHours?.title}</h3>
                            {data.openingHours?.openingHours
                                ?.filter((p) => !p.isClosed)
                                .map((p) => (
                                    <Fragment key={p._key}>
                                        <span>{p.days}</span>
                                        <span>
                                            {p.open} - {p.close}
                                        </span>
                                    </Fragment>
                                ))}
                        </div>
                        <menu className={style.contactInfo}>
                            <li>
                                <a href={`tel:${data.contact?.phone?.replaceAll(/\s/g, '')}`} className={style.footerButton}>
                                    <Icon className="icon-phone" />
                                    <div>{data.contact?.phone}</div>
                                </a>
                            </li>
                            <li>
                                <a href={`mailto:${data.contact?.email}`} className={style.footerButton}>
                                    <Icon className="icon-email" />
                                    <div>{data.contact?.email}</div>
                                </a>
                            </li>
                        </menu>
                        <menu className={style.socialMedia}>
                            <li>
                                <a href={data.facebook} className={style.footerIconLink}>
                                    <img src={facebook} loading="lazy" alt="Facebook logo" />
                                    Facebook
                                </a>
                            </li>
                            <li>
                                <a href={data.linkedIn} className={style.footerIconLink}>
                                    <img src={linkedIn} loading="lazy" alt="LinkedIn logo" />
                                    LinkedIn
                                </a>
                            </li>
                        </menu>
                    </div>
                </div>
                <div className={style.extendedFooter}>
                    <img src={crest} loading="lazy" alt="Vinmonopolet logo" />
                    <p>
                        {data.address}
                        <br />
                        Organisasjonsnummer: {data.organizationNumber}
                        <br />
                        Telefonnummer: {data.contact?.phone}
                    </p>
                    <a href={data.linkToEnglishPage?.link?.internalReference.path} className={style.footerButton}>
                        <div>{data.linkToEnglishPage?.name}</div>
                    </a>
                </div>
            </div>
        </div>
    );
}
